import { takeEvery } from 'typed-redux-saga'
import { chatSocketSlice } from 'Pages/chat'
import { closeChatConnection } from './closeChatConnection'
import { subscribeChatChannels } from './subscribeChatChannel'
import { unSubscribeChatChannels } from './unSubscribeChatChannel'
import { sendMessage, sendPingMessage } from './sendChatMessage'

export function* chatSocketSaga() {
	yield* takeEvery(chatSocketSlice.actions.subscribeChannels, subscribeChatChannels)
	yield* takeEvery(chatSocketSlice.actions.unSubscribeChannels, unSubscribeChatChannels)
	yield* takeEvery(chatSocketSlice.actions.closeConnection, closeChatConnection)
	yield* takeEvery(chatSocketSlice.actions.sendMessage, sendMessage)
	yield* takeEvery(chatSocketSlice.actions.sendPingMessage, sendPingMessage)
}
